<template>
  <div class="loadingState">
    <div class="spinner" :class="[color, size]">
      <div class="bounce1" />
      <div class="bounce2" />
      <div class="bounce3" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'black'
    },

    size: {
      type: String,
      default: 'normal'
    }
  }
}
</script>

<style scoped>
.spinner {
  margin: 0 auto;
  width: 70px;
  text-align: center;
}

.spinner > div
{
  width: 10px;
  height: 10px;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner.normal
{
  width: 70px;
}

.spinner.normal > div
{
  width: 10px;
  height: 10px;
}

.spinner.medium
{
  width: 100px;
}

.spinner.medium > div
{
  width: 20px;
  height: 20px;
}

.spinner.black > div
{
  background-color: #333;
}

.spinner.white > div
{
  background-color: #FFF;
}

.spinner.blue > div
{
  background-color: #3ca9ca;
}

.spinner.gradientBlueGreen > div
{
  background-color: #abe9cd;
  background-image: linear-gradient(315deg, #abe9cd 0%, #3eadcf 74%);
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
}
</style>
